// Status color mapping for program elements
export const STATUS_COLORS = {
  // Primary status colors
  "Open": "#87CEEB",                    // Sky Blue
  "In Planning": "#98FB98",             // Pale Green  
  "Pre Release": "#FFD700",             // Gold
  "In Production": "#FFA500",           // Orange
  "On Hold": "#FF8C00",                 // Dark Orange
  "Machine Down": "#FF6347",            // Tomato Red
  "Maintenance": "#A9A9A9",             // Dark Gray
  "Completed": "#32CD32",               // Lime Green
  
  // Additional status colors
  "Mold SetUp In Progress": "#FFB6C1",  // Light Pink
  "Material SetUp In Progress": "#DDA0DD", // Plum
  "Mold SetUp Completed": "#20B2AA",    // Light Sea Green (distinct from In Planning)
  "Material Loaded": "#87CEFA",         // Light Sky Blue
  "Processing Started": "#F0E68C",      // Khaki
  "Mold Removal In Progress": "#FFA07A", // Light Salmon
  
  // Fallback colors
  "All": "#CCCCCC",                     // Light Gray
  "Default": "#FCA311",                 // Default Orange (original)
};

// Helper function to get color for a status
export const getStatusColor = (status) => {
  if (!status) return STATUS_COLORS.Default;
  
  const normalizedStatus = status.trim();
  return STATUS_COLORS[normalizedStatus] || STATUS_COLORS.Default;
};

// Helper function to get color with opacity for program bars
export const getStatusColorWithOpacity = (status, opacity = 0.8) => {
  const baseColor = getStatusColor(status);
  
  // Convert hex to RGB and add opacity
  const hex = baseColor.replace('#', '');
  const r = parseInt(hex.substr(0, 2), 16);
  const g = parseInt(hex.substr(2, 2), 16);
  const b = parseInt(hex.substr(4, 2), 16);
  
  return `rgba(${r}, ${g}, ${b}, ${opacity})`;
};

// Status priority mapping (for sorting/filtering)
export const STATUS_PRIORITY = {
  "Machine Down": 1,
  "On Hold": 2,
  "Maintenance": 3,
  "Open": 4,
  "In Planning": 5,
  "Pre Release": 6,
  "In Production": 7,
  "Completed": 8,
};

// Helper function to get status priority
export const getStatusPriority = (status) => {
  return STATUS_PRIORITY[status] || 99;
};
